var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center grand-summary pt-1 pb-1 mb-0"},[_c('label',{staticClass:"mb-0",attrs:{"data-test":"grandSummary"},domProps:{"innerHTML":_vm._s(_vm.resultSummary)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }